import React from 'react';

// Pastel status pills matching the fact-find badge convention.
const TONES = {
    success: { backgroundColor: '#D1FAE5', color: '#065F46' },
    neutral: { backgroundColor: '#F3F4F6', color: '#6B7280' },
    info: { backgroundColor: '#DBEAFE', color: '#1E40AF' },
    warning: { backgroundColor: '#FEF3C7', color: '#92400E' },
    error: { backgroundColor: '#FEE2E2', color: '#991B1B' },
    accent: { backgroundColor: '#EFEAFE', color: '#5B3FE0' },
};

const Badge = ({ tone = 'neutral', className = '', children }) => (
    <span
        className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide whitespace-nowrap ${className}`}
        style={TONES[tone] || TONES.neutral}
    >
        {children}
    </span>
);

export default Badge;
